
// aos js
AOS.init({
  duration: 1200,
});
// mobile version
AOS.init({disable: 'mobile'});
	AOS.init({
	disable: function() {
	  var maxWidth = 800;
	  return window.innerWidth < maxWidth;
	}
});

// banner slider js

$('#banner-slider').slick({
  dots: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  //infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        //infinite: true,
        //dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});


// category slider js

$('#category-slider').slick({
  dots: true,
  arrows: false,
  autoplay: false,
  autoplaySpeed: 3000,
  speed: 300,
  centerMode: true,
  centerPadding: '0%',
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: '<button class="slick-prev slick-arrow"><i class="fa-solid fa-arrow-left"></i></button>',
  nextArrow: '<button class="slick-next slick-arrow"><i class="fa-solid fa-arrow-right"></i></button>',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false,
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
      }
    }

  ]
  
});


// arrivals Products

$('#new-arrivals-slider').slick({
  dots: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  speed: 300,
  // centerMode: true,
  // centerPadding: '10%',
  infinite: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  prevArrow: '<button class="slick-prev slick-arrow"><i class="las la-angle-left"></i></button>',
  nextArrow: '<button class="slick-next slick-arrow"><i class="las la-angle-right"></i></button>',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    }

  ]
  
});

$(".new-arrivals-prd-left-arrow").click(function () {
  $("#new-arrivals-slider").slick("slickPrev");
});

$(".new-arrivals-prd-right-arrow").click(function () {
  $("#new-arrivals-slider").slick("slickNext");
});

/*******************/ 
$('#selected-for-you-slider').slick({
  dots: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  speed: 300,
  // centerMode: true,
  // centerPadding: '10%',
  infinite: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  prevArrow: '<button class="slick-prev slick-arrow"><i class="las la-angle-left"></i></button>',
  nextArrow: '<button class="slick-next slick-arrow"><i class="las la-angle-right"></i></button>',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    }

  ]
  
});

$(".selected-for-you-prd-left-arrow").click(function () {
  $("#selected-for-you-slider").slick("slickPrev");
});

$(".selected-for-you-prd-right-arrow").click(function () {
  $("#selected-for-you-slider").slick("slickNext");
});
/*******************/ 
$('#women-jeans-slider').slick({
  dots: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  speed: 300,
  // centerMode: true,
  // centerPadding: '10%',
  infinite: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  prevArrow: '<button class="slick-prev slick-arrow"><i class="las la-angle-left"></i></button>',
  nextArrow: '<button class="slick-next slick-arrow"><i class="las la-angle-right"></i></button>',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    }

  ]
  
});

$(".women-jeans-prd-left-arrow").click(function () {
  $("#women-jeans-slider").slick("slickPrev");
});

$(".women-jeans-prd-right-arrow").click(function () {
  $("#women-jeans-slider").slick("slickNext");
});

/*******************/ 
$('#books-for-you-slider').slick({
  dots: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  speed: 300,
  // centerMode: true,
  // centerPadding: '10%',
  infinite: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  prevArrow: '<button class="slick-prev slick-arrow"><i class="las la-angle-left"></i></button>',
  nextArrow: '<button class="slick-next slick-arrow"><i class="las la-angle-right"></i></button>',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    }

  ]
  
});

$(".books-for-you-prd-left-arrow").click(function () {
  $("#books-for-you-slider").slick("slickPrev");
});

$(".books-for-you-prd-right-arrow").click(function () {
  $("#books-for-you-slider").slick("slickNext");
});

/*******************/ 
/*shop-by-style slider*/ 
$('#shop-by-style-slider').slick({
  dots: false,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 3000,
  speed: 300,
  infinite: true,
  slidesToShow: 6,
  slidesToScroll: 1,
  prevArrow: '<button class="slick-prev slick-arrow"><i class="las la-arrow-left"></i></button>',
  nextArrow: '<button class="slick-next slick-arrow"><i class="las la-arrow-right"></i></button>',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }

  ]
  
});

// 
// brands slider js
$('#brands-slider').slick({
  dots: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 0,
  //infinite: false,
  speed: 8000,
  slidesToShow: 9,
  slidesToScroll: 1,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
        //infinite: true,
        //dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }

  ]
});

/*******************/ 
$('#youtube-video-slider').slick({
  dots: false,
  arrows: false,
  autoplay: false,
  autoplaySpeed: 3000,
  speed: 300,
  // centerMode: true,
  // centerPadding: '10%',
  infinite: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  prevArrow: '<button class="slick-prev slick-arrow"><i class="las la-angle-left"></i></button>',
  nextArrow: '<button class="slick-next slick-arrow"><i class="las la-angle-right"></i></button>',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    }

  ]
  
});

$(".youtube-video-prd-left-arrow").click(function () {
  $("#youtube-video-slider").slick("slickPrev");
});

$(".youtube-video-prd-right-arrow").click(function () {
  $("#youtube-video-slider").slick("slickNext");
});

/*####### Shop page js*/ 
$(document).ready(function () {
    $(".category_head .plusminus").click(function () {
        let head = $(this).parent(); // go up to .accordion_head
        let body = head.next(".category_nav_wrap"); // get its sibling body

        if (body.is(':visible')) {
            body.slideUp(300);
            $(this).text('+');
        } else {
            $(".category_nav_wrap").slideUp(300); // close all
            $(".plusminus").text('+');         // reset all plus
            body.slideDown(300);               // open this one
            $(this).text('-');                 // set minus
        }
    });
});

$(".mobile-filter-tigger").click(function () {
  $(".left-sidebar").slideToggle();
});

/*####### Shop page js end*/ 

$(document).ready(function(){
    $(".sub-cat-active").closest('.product-categories-list').find('.category_nav_wrap').css("display", "block");
    $(".sub-cat-active").closest('.product-categories-list').find(".category_head .plusminus").text('-'); 
});